import * as React from 'react';
const { useCallback, useMemo } = React;
import {
	Switch,
	Route,
	Redirect,
	RouteComponentProps,
} from 'react-router-dom';
import { BaseRoute } from '@seeneco-ui/core/models/routing';
import NavPicker, { NavPickerDataSourceItem } from '@seeneco-ui/core/components/nav-picker';
import { concatRouteUrl } from '@seeneco-ui/core/utils/url';

import {
	Root,
	NavigatorLayout,
	ContentLayout,
} from './styled';


type TenantAccountEntryProps = {
	path: string;
	routes: Array<BaseRoute>;
	onChangePath: (value: string) => void;
} & RouteComponentProps<any>;

const TenantAccountEntry: React.SFC<TenantAccountEntryProps> = (props) => {
	const {
		path,
		match,
		routes,
		onChangePath,
	} = props;
	const dataSource: Array<NavPickerDataSourceItem> = useMemo(() => routes.map(x => ({ value: x.path, text: x.name })), []);
	const onChangeRoute = useCallback((e: React.SyntheticEvent, value: string) => onChangePath(concatRouteUrl(match.path, value)), []);

	return (
		<Root>
			<NavigatorLayout>
				<NavPicker
					dataSource={dataSource}
					value={path}
					onChange={onChangeRoute}
				/>
			</NavigatorLayout>
			<ContentLayout>
				<Switch>
					{routes.map((route, idx) => {
						return (
							<Route
								key={idx}
								path={concatRouteUrl(match.path, route.path)}
								component={route.component}
							/>
						)
					})}
					{
						routes[0] &&
						<Redirect
							key='redirect'
							to={concatRouteUrl(match.path, routes[0].path)}
						/>
					}
				</Switch>
			</ContentLayout>
		</Root>
	);
}

TenantAccountEntry.displayName = 'TenantAccountEntry';
TenantAccountEntry.defaultProps = {};

export default TenantAccountEntry;
